export const basicInfo = [
  {
    groupName: "Hammad Aslam",
    groupMembers: ["Hammad Aslam", "Saad Afzal"],
    className: "BSIT Post ADP",
    coordinatorName: "Farrah Aslam",
    projectTitle: "Opinio Mine",
    projectDetails:
      "Customer reviews classification and analysis system using data mining and nlp",
    coordinatorStatus: "pending",
    supervisorStatus: "Approved",
  },
  {
    groupName: "Ahsan Usman",
    groupMembers: ["Ahsan Usman", "Ahmad Jawad"],
    className: "BSCS 2021-25",
    coordinatorName: "Farrah Aslam",
    projectTitle: "Online Assignment Plagiarism Checker",
    projectDetails:
      "online system for checking plagiarism from the documents",
    coordinatorStatus: "pending",
    supervisorStatus: "Rejected",
  },
];
